import { render, staticRenderFns } from "./GamePlay.vue?vue&type=template&id=dbc0f89e&scoped=true"
import script from "./GamePlay.vue?vue&type=script&lang=ts"
export * from "./GamePlay.vue?vue&type=script&lang=ts"
import style0 from "./GamePlay.vue?vue&type=style&index=0&id=dbc0f89e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc0f89e",
  null
  
)

export default component.exports